import * as React from 'react';
import { OnIgnoreEnter } from '../AnalyseApp';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface DisputedListButtonProps {
    acceptanceErrorMessageVisible: boolean;
    onClick: () => void;
}

export const DisputedListButton = (props: DisputedListButtonProps) => {

    return (
        <button id="DisputedList" className="btn btn-primary" type="button" onClick={() => props.onClick()} onKeyDown={OnIgnoreEnter}>
            Disputed Events&nbsp;{props.acceptanceErrorMessageVisible ? <FontAwesomeIcon icon={faTriangleExclamation} className="text-warning" /> : null}
        </button>
    );
}
